"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeForIconButtonType = exports.getThemeForButtonType = void 0;
var utils_1 = require("../../../utils");
exports.getThemeForButtonType = function (type) {
    switch (type) {
        case 'SECONDARY':
            return {
                background: 'transparent',
                border: utils_1.theme.colors.NTDarkGrey[300],
                color: utils_1.theme.colors.NTDarkGrey[900],
                hoverBackground: utils_1.theme.colors.NTDarkGrey[100],
                focusBackground: utils_1.theme.colors.button.secondary,
                focusColor: utils_1.theme.colors.white,
                focusBorderColor: utils_1.theme.colors.green[400],
                disabledBorder: utils_1.theme.colors.NTDarkGrey[300],
                height: '3.2rem',
            };
        case 'SECONDARY_DARK':
            return {
                background: 'transparent',
                border: utils_1.theme.colors.NTDarkGrey[400],
                color: utils_1.theme.colors.white,
                hoverBackground: utils_1.theme.colors.NTDarkGrey[800],
                focusBackground: utils_1.theme.colors.white,
                focusColor: utils_1.theme.colors.NTDarkGrey[900],
                focusBorderColor: utils_1.theme.colors.green[400],
                disabledBorder: utils_1.theme.colors.white,
                height: '3.2rem',
            };
        case 'SECONDARY_DARK_PANE':
            return {
                background: utils_1.theme.colors.NTDarkGrey[800],
                border: utils_1.theme.colors.NTDarkGrey[800],
                color: utils_1.theme.colors.white,
                hoverBackground: utils_1.theme.colors.NTDarkGrey[800],
                focusBackground: utils_1.theme.colors.NTDarkGrey[800],
                focusColor: utils_1.theme.colors.white,
                focusBorderColor: utils_1.theme.colors.green[500],
                disabledBorder: utils_1.theme.colors.NTDarkGrey[800],
                height: '3.2rem',
            };
        case 'NAVIGATION':
            return {
                background: utils_1.theme.colors.aqua[700],
                border: utils_1.theme.colors.aqua[700],
                color: utils_1.theme.colors.white,
                hoverBackground: '#043134',
                focusBackground: '#043134',
                focusColor: utils_1.theme.colors.white,
                focusBorderColor: utils_1.theme.colors.aqua[700],
                disabledBorder: utils_1.theme.colors.aqua[700],
                height: '4.8rem',
            };
        default:
            return {
                background: utils_1.theme.colors.darkGreen[600],
                border: utils_1.theme.colors.darkGreen[600],
                color: utils_1.theme.colors.white,
                focusBackground: utils_1.theme.colors.darkGreen[800],
                focusColor: utils_1.theme.colors.white,
                focusBorderColor: utils_1.theme.colors.green[400],
                disabledBorder: utils_1.theme.colors.darkGreen[600],
                height: '3.2rem',
            };
    }
};
exports.getThemeForIconButtonType = function (type, toggled) {
    switch (type) {
        case 'DARK': {
            return {
                background: toggled ? utils_1.theme.colors.NTDarkGrey[100] : 'none',
                color: utils_1.theme.colors.white,
                hoverBackground: toggled
                    ? utils_1.theme.colors.NTDarkGrey[100]
                    : utils_1.theme.colors.NTDarkGrey[800],
                hoverColor: utils_1.theme.colors.white,
                focusBackground: utils_1.theme.colors.NTDarkGrey[100],
                focusColor: toggled ? undefined : utils_1.theme.colors.NTDarkGrey[900],
                focusVisibleBackground: utils_1.theme.colors.NTDarkGrey[100],
                focusVisibleColor: toggled
                    ? utils_1.theme.colors.white
                    : utils_1.theme.colors.NTDarkGrey[700],
            };
        }
        default: {
            return {
                background: toggled ? utils_1.theme.colors.button.secondary : 'none',
                color: toggled ? utils_1.theme.colors.white : utils_1.theme.colors.NTDarkGrey[900],
                hoverBackground: toggled
                    ? utils_1.theme.colors.button.secondary
                    : utils_1.theme.colors.NTDarkGrey[100],
                hoverColor: toggled ? utils_1.theme.colors.white : utils_1.theme.colors.NTDarkGrey[900],
                focusBackground: 'none',
                focusColor: toggled ? undefined : utils_1.theme.colors.NTDarkGrey[900],
                focusVisibleBackground: toggled
                    ? utils_1.theme.colors.button.secondary
                    : utils_1.theme.colors.NTDarkGrey[100],
                focusVisibleColor: toggled
                    ? utils_1.theme.colors.white
                    : utils_1.theme.colors.NTDarkGrey[700],
            };
        }
    }
};
